// custom-cart-count.js

// Función global para refrescar el contador del carrito en el header B2B
window.refreshB2BCartCount = function () {
  fetch('/cart.js', {
    headers: {
      'Accept': 'application/json'
    }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Error al obtener el carrito');
      return response.json();
    })
    .then(function (cart) {
      var countEls = document.querySelectorAll('[data-header-cart-count]');
      if (!countEls.length) return;

      var newCount = cart.item_count || 0;

      countEls.forEach(function (el) {
        el.textContent = newCount;

        if (newCount > 0) {
          el.classList.add('visible');
        } else {
          el.classList.remove('visible');
        }
      });
    })
    .catch(function (error) {
      console.error('No se pudo actualizar el contador del carrito (B2B):', error);
    });
};

// Detectar clicks en botones de "Añadir al carrito"
document.addEventListener('click', function (event) {
  var addButton = event.target.closest(
    // Tu botón de producto:
    '.product-form--atc-button, [data-product-atc],' +
    // Otros posibles botones:
    'button[name="add"], ' +
    '.product-form__submit, ' +
    '.js-add-to-cart, ' +
    '.product-grid-item__cta button, ' +
    'form[action*="/cart/add"] button[type="submit"]'
  );

  if (!addButton) return;

  // Dar tiempo a que el AJAX de Empire termine de agregar al carrito
  setTimeout(window.refreshB2BCartCount, 700);
});

// Opcional: actualizar contador cuando cambian cantidades desde el carrito
document.addEventListener('change', function (event) {
  if (event.target.matches('input[name="updates[]"], .cart__qty-input')) {
    setTimeout(window.refreshB2BCartCount, 500);
  }
});

// Actualizar al cargar, por si el carrito cambió en otra página/pestaña
document.addEventListener('DOMContentLoaded', function () {
  window.refreshB2BCartCount();
});
